import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import LandingPage from '@/pages/LandingPage';
import WebinarPage from '@/pages/WebinarPage';
import AdminPage from '@/pages/AdminPage';
import ThankYouPage from '@/pages/ThankYouPage';
import BookedPage from '@/pages/BookedPage';

function App() {
  useEffect(() => {
    document.documentElement.classList.add('dark');
    document.body.style.backgroundColor = '#000000';

    // Seamlessly hide platform branding
    const hideBadge = () => {
      document.querySelectorAll(
        'a[href*="emergent"], [class*="powered"], [class*="watermark"], [id*="watermark"]'
      ).forEach(el => { el.style.display = 'none'; });
    };
    hideBadge();
    const observer = new MutationObserver(hideBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/webinar" element={<WebinarPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/booked" element={<BookedPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
